import "./clickthrough-overlay.css";

const OVERLAY_CLASS = "tre-cta-overlay";
const ANCHOR_CLASS = "tre-cta-overlay-anchor";

const escapeHandlers = new WeakMap<
  HTMLElement,
  (event: KeyboardEvent) => void
>();

function removeOverlay(overlay: HTMLElement, anchor: HTMLElement): void {
  const onEscape = escapeHandlers.get(overlay);
  if (onEscape) {
    document.removeEventListener("keydown", onEscape);
    escapeHandlers.delete(overlay);
  }
  overlay.remove();
  if (!anchor.querySelector(`.${OVERLAY_CLASS}`)) {
    anchor.classList.remove(ANCHOR_CLASS);
  }
}

function isCtaOpenMessage(data: unknown): boolean {
  return (
    data === "tre_open" || (data as { type?: string })?.type === "tre_open"
  );
}

/** Parent element that should host the overlay (typically `.iframe-wrapper`). */
export function getClickthroughOverlayAnchor(
  iframe: HTMLIFrameElement
): HTMLElement {
  return iframe.parentElement ?? iframe;
}

export function showClickthroughOverlay(anchor: HTMLElement): void {
  if (anchor.querySelector(`.${OVERLAY_CLASS}`)) {
    return;
  }

  const overlay = document.createElement("div");
  overlay.className = OVERLAY_CLASS;
  overlay.setAttribute("role", "dialog");
  overlay.setAttribute("aria-label", "CTA triggered");

  overlay.innerHTML = `
    <div class="tre-cta-overlay__content">
      <p class="tre-cta-overlay__title">&#128073;&nbsp; CTA Triggered &nbsp;&#128072;</p>
      <p class="tre-cta-overlay__hint">Tap to return to the ad</p>
    </div>
  `;

  anchor.classList.add(ANCHOR_CLASS);

  const dismiss = () => {
    removeOverlay(overlay, anchor);
  };

  const onEscape = (event: KeyboardEvent) => {
    if (event.key !== "Escape") {
      return;
    }
    dismiss();
  };

  escapeHandlers.set(overlay, onEscape);
  overlay.addEventListener("click", dismiss);
  document.addEventListener("keydown", onEscape);
  anchor.appendChild(overlay);
}

export function dismissClickthroughOverlays(): void {
  document.querySelectorAll(`.${OVERLAY_CLASS}`).forEach((el) => {
    const overlay = el as HTMLElement;
    const anchor = overlay.parentElement;
    if (anchor) {
      removeOverlay(overlay, anchor);
    }
  });
}

export function handleRawAssetCtaMessage(
  event: MessageEvent,
  iframe: HTMLIFrameElement,
  allowedOrigins: Set<string>
): void {
  if (!isCtaOpenMessage(event.data)) {
    return;
  }
  if (event.source !== iframe.contentWindow) {
    return;
  }
  if (!allowedOrigins.has(event.origin)) {
    return;
  }

  showClickthroughOverlay(getClickthroughOverlayAnchor(iframe));
}
